/**
 * Shared display-text helpers for chat-thread widget cards.
 */

/**
 * Capitalise the first non-whitespace character of a string, leaving the rest
 * untouched. Applied to every free-text prose slot on the chat cards so a model
 * fragment like "founders will pay" renders as "Founders will pay". Never
 * lower-cases the remainder — "iOS adoption" stays "iOS adoption". Safe on
 * empty / whitespace-only input, and a no-op on already-capitalised text.
 */
export function capitalizeFirst(raw: string): string {
  if (!raw) return raw;
  const i = raw.search(/\S/);
  if (i < 0) return raw;
  return raw.slice(0, i) + raw.charAt(i).toUpperCase() + raw.slice(i + 1);
}
